import { Link } from 'react-router-dom';
import type { Tournament } from '../api/types';
import { dayNum, money, monthAbbr, timeLabel } from '../format';
import { track } from '../analytics';

export function TournamentCard({ t }: { t: Tournament }) {
  const live = t.status === 'in_progress';
  const cancelled = t.status === 'cancelled';
  // registrationOpen с сервера уже учитывает старт, late reg идущей игры и
  // грейс-окно до запуска Korin — локально время старта не перепроверяем.
  const open = !cancelled && t.registrationOpen;
  const meta = [
    timeLabel(t.startTime),
    t.format,
    t.buyIn > 0 ? money(t.buyIn) : 'Free',
  ]
    .filter(Boolean)
    .join(' · ');
  const pct =
    t.capacity && t.capacity > 0
      ? Math.min(100, Math.round(((t.registeredCount - (t.bustedCount ?? 0)) / t.capacity) * 100))
      : null;

  return (
    <Link
      to={live ? `/tournaments/${t.id}/live` : `/tournaments/${t.id}`}
      className="tcard"
      onClick={() => live && track('live_click', { gameId: t.id, from: 'schedule' })}
    >
      <div className="date">
        <div className={`d ${(open || live) && !cancelled ? '' : 'dim'}`}>{dayNum(t.startTime)}</div>
        <div className="m">{monthAbbr(t.startTime)}</div>
      </div>
      <div className="vdiv" />
      <div className="body">
        <div className="head">
          <div className="name">{t.title ?? t.format ?? 'Турнир'}</div>
          {cancelled ? (
            <span className="status-badge status-badge--closed">Отменён</span>
          ) : live ? (
            <span className="status-badge status-badge--live">● Идёт</span>
          ) : (
            <span className={`status-badge ${open ? 'status-badge--open' : 'status-badge--closed'}`}>
              {open ? 'Открыта' : 'Закрыта'}
            </span>
          )}
        </div>
        <div className="meta">{meta}</div>
        {pct !== null ? (
          <div className="signup">
            <div className="progress">
              <div className="progress-fill" style={{ width: `${pct}%` }} />
            </div>
            <span className="count">
              {t.registeredCount}/{t.capacity}
            </span>
          </div>
        ) : (
          <div className="tiny muted">{t.registeredCount} записались</div>
        )}
      </div>
    </Link>
  );
}

/** T1: finished tournament — dimmed date, «Завершён» badge, field size and the
 *  result line (winner + the viewer's own place/points). Opens the results. */
export function PastTournamentCard({ t }: { t: Tournament }) {
  const meta = [
    t.playersCount !== null ? `${t.playersCount} игроков` : null,
    t.format,
  ]
    .filter(Boolean)
    .join(' · ');
  const scored = (t.myPoints ?? 0) > 0;

  return (
    <Link to={`/tournaments/${t.id}/results`} className="tcard tcard--past">
      <div className="date">
        <div className="d dim">{dayNum(t.startTime)}</div>
        <div className="m">{monthAbbr(t.startTime)}</div>
      </div>
      <div className="vdiv" />
      <div className="body">
        <div className="head">
          <div className="name">{t.title ?? t.format ?? 'Турнир'}</div>
          <span className="status-badge status-badge--closed">Завершён</span>
        </div>
        {meta ? <div className="meta">{meta}</div> : null}
        <div className="result">
          {t.winner ? <span className="winner">Победитель · {t.winner}</span> : <span />}
          {t.myPlace !== null && (
            <span className="mine">
              <em>ВЫ</em>
              <b className={scored ? 'accent' : ''}>
                {t.myPlace}
                {scored ? ` · +${t.myPoints}` : ''}
              </b>
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
